<div class="browser-header-container">
  <span class="notification-text">For better experience, please switch to Microsoft Edge or Google Chrome browser.</span>
  <soq-icon-button class="dismiss-button" (click)="dismiss()">
    <mat-icon>close</mat-icon>
  </soq-icon-button>
</div>
